import classNames from "classnames";

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../style.module.scss";
import { routeConstant } from "shared/routes/routeConstant";

const NavItem = ({ title, Icon, path, subPaths }: SideBarItemPathType) => {
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (path === location.pathname) {
      setActive(true);
    } else {
      setActive(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <Link
        className={classNames(
          active ? styles.activeNavItemContainer : styles.navItemContainer,
          "w-full flex items-center gap-3"
        )}
        to={path ? path : ""}
      >
        {Icon && <Icon />}
        <label className={classNames(styles.heading)} role="button">
          {title}
        </label>
      </Link>
      <div
        className={classNames(styles.subPathsList, "w-full justify-between")}
      >
        {subPaths?.map((subPath: SideBarItemPathType, index: number) => {
          return <SubPath key={index} subPath={subPath} />;
        })}
      </div>
    </>
  );
};

const SubPath = ({ subPath: { path, title, Icon } }: any) => {
  const location = useLocation();
  const [isActivePath, setIsActivePath] = useState<boolean>(false);
  useEffect(() => {
    if (location.pathname === path) {
      setIsActivePath(true);
    } else {
      setIsActivePath(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  return (
    <Link
      to={path ? path : ""}
      className={classNames(
        isActivePath
          ? styles.activeSubNavItemContainer
          : styles.navItemContainer,
        "w-full justify-between"
      )}
    >
      <div className={classNames("flex items-center", styles.subPathContainer)}>
        {Icon && <Icon />}
        <label className={classNames(styles.heading)} role="button">
          {title}
        </label>
      </div>
    </Link>
  );
};

export default NavItem;
